import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e35991e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-menu" }
const _hoisted_2 = {
  ref: "bgRef",
  class: "bottom-menu__bg",
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 428 88"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M810.74,384.5H666.39a14.61,14.61,0,0,0-14.5,14.85c0,.5,0,1,0,1.5a34.89,34.89,0,0,1-69.76-1.35v-.16A14.61,14.61,0,0,0,567.6,384.5H423.26A20.26,20.26,0,0,0,403,404.76V472.5H831V404.76A20.26,20.26,0,0,0,810.74,384.5Z",
  transform: "translate(-403 -384.5)"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "bottom-menu__item" }
const _hoisted_6 = {
  key: 0,
  class: "bottom-menu__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "20"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  fill: "#0C1229",
  d: "M5.143 19.894h-.011a5.138 5.138 0 0 1-3.726-1.372 5.105 5.105 0 0 1-1.383-3.716L.012 6.531a5.044 5.044 0 0 1 1.214-3.478A4.918 4.918 0 0 1 4.5 1.539V.794a.765.765 0 0 1 .219-.55.765.765 0 0 1 1.295.549v.695l5.842-.008V.784a.76.76 0 0 1 .217-.549.764.764 0 0 1 1.294.547v.745a4.945 4.945 0 0 1 3.308 1.478 4.952 4.952 0 0 1 1.254 3.463l.011 8.374c0 3.105-1.953 5.038-5.108 5.042l-7.689.01zm7.86-5.772a.829.829 0 0 0-.806.846.827.827 0 0 0 1.653-.042.827.827 0 0 0-.837-.804h-.01zm-8.094 0a.847.847 0 0 0-.805.855.82.82 0 0 0 .808.795h.039a.816.816 0 0 0 .777-.86.81.81 0 0 0-.816-.795l-.003.005zm4.052-.005a.851.851 0 0 0-.805.856.82.82 0 0 0 .811.795h.036a.82.82 0 0 0 .776-.856.81.81 0 0 0-.816-.795h-.002zm-4.057-3.57a.847.847 0 0 0-.805.854.817.817 0 0 0 .809.795h.039a.818.818 0 0 0 .774-.859.807.807 0 0 0-.815-.795l-.002.005zm4.053-.035a.847.847 0 0 0-.806.855c.013.439.371.79.812.794h.036a.82.82 0 0 0 .775-.855.81.81 0 0 0-.815-.795l-.002.001zm4.054.006a.822.822 0 0 0-.805.834v.012a.81.81 0 0 0 .818.795h.019a.82.82 0 0 0-.028-1.639l-.004-.002zM4.502 3.057c-1.977.199-2.979 1.367-2.976 3.472v.309l14.888-.02V6.47c-.04-2.1-1.064-3.252-3.042-3.423v.765a.76.76 0 0 1-1.295.543.763.763 0 0 1-.215-.541V3.01l-5.842.008v.803a.76.76 0 0 1-1.295.543.766.766 0 0 1-.216-.542v-.766l-.007.001z"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "bottom-menu__icon",
  width: "21",
  height: "23"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  fill: "#AFB7BD",
  d: "M15.271 22.365H6.618C3.134 22.365.97 20.22.97 16.77V7.527c0-3.203 1.94-5.238 5.079-5.463v-.891a.767.767 0 0 1 1.535 0v.847h6.73v-.847a.767.767 0 0 1 1.535 0v.891c1.487.104 2.737.591 3.613 1.467.958.96 1.462 2.343 1.457 3.998v9.318c0 3.403-2.165 5.518-5.648 5.518zm-8.653-1.532h8.653c2.652 0 4.113-1.416 4.113-3.986V9.501H2.504v7.269c0 2.62 1.461 4.063 4.114 4.063zm11.757-16.22c-.589-.59-1.464-.927-2.526-1.02v.941a.767.767 0 0 1-1.535 0v-.982h-6.73v.982a.767.767 0 0 1-1.535 0v-.942c-2.283.196-3.545 1.566-3.545 3.935v.442h16.88v-.442c.004-1.26-.335-2.24-1.009-2.914zM6.4 11.957h.009a.766.766 0 1 1 0 1.532.771.771 0 0 1-.772-.766c0-.423.34-.766.763-.766zm0 3.97h.009a.766.766 0 1 1 0 1.532.771.771 0 0 1-.772-.766c0-.423.34-.766.763-.766zm4.549-3.97h.01a.767.767 0 1 1 0 1.532.77.77 0 0 1-.772-.766c0-.423.338-.766.762-.766zm0 3.97h.01a.767.767 0 1 1 0 1.532.77.77 0 0 1-.772-.766c0-.423.338-.766.762-.766zm4.54-3.97h.01a.767.767 0 1 1 0 1.532.77.77 0 0 1-.772-.766c0-.423.339-.766.762-.766zm0 3.97h.01a.767.767 0 1 1 0 1.532.77.77 0 0 1-.772-.766c0-.423.339-.766.762-.766z"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bottom-menu__title" }, "تراکنش ها", -1))
const _hoisted_13 = { class: "bottom-menu__item" }
const _hoisted_14 = {
  key: 0,
  class: "bottom-menu__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  fill: "#0C1229",
  d: "M15.391 17.874H6.422a5.607 5.607 0 0 1-4.009-1.4 5.276 5.276 0 0 1-1.439-3.897V5.312a5.276 5.276 0 0 1 1.439-3.897 5.607 5.607 0 0 1 4.009-1.4h8.97A5.583 5.583 0 0 1 19.4 1.421a5.348 5.348 0 0 1 1.439 3.934h-4.203v.034a3.558 3.558 0 0 0-2.496 1.009 3.373 3.373 0 0 0-1.036 2.429 3.491 3.491 0 0 0 3.532 3.44h4.203v.309a5.277 5.277 0 0 1-1.44 3.897 5.6 5.6 0 0 1-4.008 1.401zM5.68 3.876a.752.752 0 0 0-.759.731.76.76 0 0 0 .759.748h5.607a.74.74 0 0 0 0-1.479H5.68zm14.417 6.913h-3.411a2.086 2.086 0 0 1-2.045-1.582 1.956 1.956 0 0 1 .43-1.639c.39-.46.961-.728 1.565-.734h3.461a.735.735 0 0 1 .742.721v2.512a.746.746 0 0 1-.742.721v.001zm-3.321-2.795a.752.752 0 0 0-.526.21.726.726 0 0 0-.224.52.76.76 0 0 0 .76.748h.327a.739.739 0 1 0 .001-1.478h-.338z"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "bottom-menu__icon",
  width: "22",
  height: "20"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  fill: "#AFB7BD",
  d: "M15.361 19.929H6.58c-3.36 0-6.094-2.669-6.094-5.949V6.862C.486 3.581 3.22.913 6.58.913h8.781c3.36 0 6.093 2.668 6.093 5.949v7.118c0 3.28-2.733 5.949-6.093 5.949zm4.57-11.565h-3.352c-1.088 0-1.973.864-1.973 1.926 0 1.061.885 1.925 1.973 1.925h3.352V8.364zm0 5.339h-3.352c-1.928 0-3.497-1.532-3.497-3.413 0-1.882 1.569-3.414 3.497-3.414h3.352v-.014c0-2.461-2.05-4.462-4.57-4.462H6.58c-2.52 0-4.57 2.001-4.57 4.462v7.118c0 2.46 2.05 4.461 4.57 4.461h8.781c2.52 0 4.57-2.001 4.57-4.461v-.277zm-8.588-6.802H5.857a.753.753 0 0 1-.762-.744c0-.41.341-.743.762-.743h5.486c.42 0 .762.333.762.743a.754.754 0 0 1-.762.744zm4.623 3.327c0-.41.342-.743.762-.743h.317c.421 0 .762.333.762.743a.753.753 0 0 1-.762.744h-.317a.754.754 0 0 1-.762-.744z"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bottom-menu__title" }, "حساب ها", -1))
const _hoisted_21 = { class: "bottom-menu__item bottom-menu__item--main" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bottom-menu__main" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "bottom-menu__icon",
    width: "28",
    height: "25"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      fill: "#FFF",
      d: "m27.272 19.065-5.638 5.63a1.044 1.044 0 0 1-1.47 0l-5.639-5.63a1.025 1.025 0 0 1 .004-1.457 1.044 1.044 0 0 1 1.466.004l3.867 3.861V5.267c0-.568.464-1.029 1.037-1.029.572 0 1.037.461 1.037 1.029v16.205l3.866-3.86a1.044 1.044 0 0 1 1.466-.004c.406.402.408 1.054.004 1.457zM12.809 8.199c-.266 0-.533-.1-.736-.303L8.208 4.038v16.2c0 .569-.464 1.03-1.037 1.03a1.034 1.034 0 0 1-1.037-1.03V4.035L2.266 7.896A1.042 1.042 0 0 1 .8 7.899a1.024 1.024 0 0 1-.004-1.456L6.434.815c.029-.028.067-.039.099-.063.177-.142.393-.239.638-.239.28 0 .532.113.719.292.004.004.011.005.015.01l5.639 5.628a1.025 1.025 0 0 1-.004 1.456c-.202.201-.467.3-.731.3z"
    })
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bottom-menu__title" }, "خرید و فروش", -1))
const _hoisted_24 = { class: "bottom-menu__item" }
const _hoisted_25 = {
  key: 0,
  class: "bottom-menu__badge"
}
const _hoisted_26 = {
  key: 1,
  class: "bottom-menu__icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.994 20a9.953 9.953 0 0 1-4.918-1.299 2.204 2.204 0 0 0-1.106-.424c-.13.001-.26.022-.383.063l-2.019.6a.785.785 0 0 1-.226.036.621.621 0 0 1-.5-.239.65.65 0 0 1-.094-.578l.67-2.242a1.045 1.045 0 0 0-.07-.899 10.572 10.572 0 0 1-1.35-4.996 10.147 10.147 0 0 1 2.83-6.976 9.887 9.887 0 0 1 7.186-3.03 9.863 9.863 0 0 1 7.116 2.991 10.05 10.05 0 0 1 2.099 3.18c.503 1.206.761 2.5.76 3.806a10.126 10.126 0 0 1-.864 4.169 9.605 9.605 0 0 1-2.274 3.15A10.244 10.244 0 0 1 9.994 20zm4.588-11.248a1.281 1.281 0 1 0 1.279 1.283v-.002a1.28 1.28 0 0 0-1.279-1.281zm-4.627 0a1.268 1.268 0 0 0-1.261 1.271 1.28 1.28 0 0 0 2.559.016 1.279 1.279 0 0 0-1.271-1.287h-.027zm-4.589 0a1.28 1.28 0 1 0 1.279 1.283v-.002c0-.707-.572-1.279-1.279-1.281z"
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  class: "bottom-menu__icon",
  width: "22",
  height: "22"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  fill: "#AFB7BD",
  d: "M18.665 18.855c-2.08 2.056-4.876 3.144-7.708 3.144a10.91 10.91 0 0 1-4.559-.993 3.372 3.372 0 0 0-1.187-.334c-.264.005-.709.157-1.14.303-.885.301-1.984.676-2.798-.129-.811-.801-.436-1.887-.135-2.761.148-.43.301-.874.301-1.21a3.187 3.187 0 0 0-.318-1.086A10.588 10.588 0 0 1 .77 7.551c.998-2.698 3-4.849 5.634-6.058C11.841-1 18.317 1.347 20.838 6.727c1.91 4.076 1.037 8.95-2.173 12.128zm.797-11.496C17.292 2.73 11.72.71 7.042 2.855a9.235 9.235 0 0 0-4.849 5.212 9.114 9.114 0 0 0 .297 7.078c.256.516.413 1.081.464 1.666.002.649-.202 1.239-.381 1.759-.147.428-.37 1.075-.228 1.214.145.144.799-.08 1.233-.227.521-.178 1.112-.38 1.698-.382a4.89 4.89 0 0 1 1.777.477c3.53 1.621 7.773.878 10.539-1.858 2.762-2.735 3.513-6.929 1.87-10.435zm-3.781 5.011a.898.898 0 0 1-.323.22c-.131.05-.253.079-.395.079-.131 0-.262-.029-.384-.079a.898.898 0 0 1-.323-.22.994.994 0 0 1-.304-.701c0-.14.031-.27.081-.39a.883.883 0 0 1 .223-.32c.364-.37 1.041-.38 1.425 0 .092.09.172.2.223.32.05.12.07.25.07.39 0 .13-.02.26-.07.38-.051.12-.131.231-.223.321zm-4.055 0a.89.89 0 0 1-.323.22c-.132.05-.252.079-.394.079a1.007 1.007 0 0 1-.708-.299.996.996 0 0 1-.304-.701c0-.14.031-.27.081-.39a.87.87 0 0 1 .223-.32c.374-.38 1.051-.37 1.425 0 .091.09.172.2.223.32.051.13.071.25.071.39 0 .13-.02.26-.071.38-.051.12-.132.231-.223.321zm-4.055 0a.881.881 0 0 1-.323.22c-.121.05-.253.079-.394.079a1.02 1.02 0 0 1-.385-.079.898.898 0 0 1-.323-.22.996.996 0 0 1-.304-.701c0-.14.031-.27.081-.39.051-.12.132-.23.223-.32.374-.38 1.052-.38 1.425 0 .092.09.173.2.223.32.05.12.071.25.071.39 0 .13-.021.26-.071.38a.996.996 0 0 1-.223.321z"
}, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bottom-menu__title" }, "پشتیبانی", -1))
const _hoisted_33 = { class: "bottom-menu__item" }
const _hoisted_34 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "bottom-menu__icon",
  width: "16",
  height: "20"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M0 16.575c0-2.721 3.686-3.398 8-3.398 4.339 0 8 .699 8 3.422 0 2.724-3.685 3.4-8 3.4-4.338 0-8-.7-8-3.424zm2.706-11.28a5.294 5.294 0 0 1 10.588-.004 5.295 5.295 0 0 1-5.292 5.295H8a5.273 5.273 0 0 1-5.294-5.252v-.039z"
}, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "bottom-menu__icon",
  width: "17",
  height: "21"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  fill: "#AFB7BD",
  d: "M8.84 20.94c-1.976 0-7.991 0-7.991-3.725 0-3.32 4.561-3.703 7.991-3.703 1.977 0 7.992 0 7.992 3.724 0 3.32-4.561 3.704-7.992 3.704zm0-5.917c-4.298 0-6.477.738-6.477 2.192 0 1.469 2.179 2.214 6.477 2.214 4.299 0 6.478-.738 6.478-2.193 0-1.469-2.179-2.213-6.478-2.213zm.007-3.401h-.035c-2.927-.011-5.315-2.395-5.325-5.315A5.29 5.29 0 0 1 5.038 2.53 5.31 5.31 0 0 1 8.81.954h.019a5.31 5.31 0 0 1 3.763 1.55 5.292 5.292 0 0 1 1.578 3.765 5.292 5.292 0 0 1-1.551 3.777 5.313 5.313 0 0 1-3.772 1.576zm2.729-8.096a3.876 3.876 0 0 0-2.748-1.131h-.013a3.901 3.901 0 0 0-3.887 3.906 3.907 3.907 0 0 0 3.887 3.881l.03.72-.003-.72a3.901 3.901 0 0 0 3.887-3.907 3.864 3.864 0 0 0-1.153-2.749z"
}, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bottom-menu__title" }, "پروفایل", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4, 512)),
    _createElementVNode("ul", {
      class: "bottom-menu__left",
      style: _normalizeStyle({ height: `${_ctx.height}px` })
    }, [
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'Transactions' },
          exact: "",
          class: _normalizeClass([
            'bottom-menu__link',
            _ctx.$route.name === 'Transactions' && 'bottom-menu__link--active',
          ])
        }, {
          default: _withCtx(() => [
            (_ctx.$route.name === 'Transactions')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
              : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11)),
            _hoisted_12
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("li", _hoisted_13, [
        _createVNode(_component_router_link, {
          to: { name: 'Account' },
          exact: "",
          class: _normalizeClass([
            'bottom-menu__link',
            _ctx.$route.name === 'Account' && 'bottom-menu__link--active',
          ])
        }, {
          default: _withCtx(() => [
            (_ctx.$route.name === 'Account')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))
              : (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19)),
            _hoisted_20
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ], 4),
    _createElementVNode("ul", {
      class: "bottom-menu__center",
      style: _normalizeStyle({ height: `${_ctx.height}px` })
    }, [
      _createElementVNode("li", _hoisted_21, [
        _createVNode(_component_router_link, {
          exact: "",
          to: { name: 'Order' },
          class: _normalizeClass([
            'bottom-menu__link',
            _ctx.$route.path.includes('order') && 'bottom-menu__link--active',
          ])
        }, {
          default: _withCtx(() => [
            _hoisted_22,
            _hoisted_23
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ], 4),
    _createElementVNode("ul", {
      class: "bottom-menu__right",
      style: _normalizeStyle({ height: `${_ctx.height}px` })
    }, [
      _createElementVNode("li", _hoisted_24, [
        _createVNode(_component_router_link, {
          to: { name: 'Support' },
          "active-class": "bottom-menu__link--active",
          class: "bottom-menu__link",
          exact: ""
        }, {
          default: _withCtx(() => [
            (_ctx.unreadCount)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.unreadCount), 1))
              : _createCommentVNode("", true),
            (_ctx.$route.name === 'Support')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_26, _hoisted_28))
              : (_openBlock(), _createElementBlock("svg", _hoisted_29, _hoisted_31)),
            _hoisted_32
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_33, [
        _createVNode(_component_router_link, {
          to: { name: 'Profile' },
          "active-class": "bottom-menu__link--active",
          class: "bottom-menu__link",
          exact: ""
        }, {
          default: _withCtx(() => [
            (_ctx.$route.name === 'Profile')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_34, _hoisted_36))
              : (_openBlock(), _createElementBlock("svg", _hoisted_37, _hoisted_39)),
            _hoisted_40
          ]),
          _: 1
        })
      ])
    ], 4)
  ]))
}